<template>
    <el-menu :default-active="activeIndex" class="" mode="horizontal" @select="handleSelect">
        <el-menu-item index="1">
            <app-house-icon/>
            خانه
        </el-menu-item>
        <el-menu-item index="2">
            <app-student-cap-icon/>
            دروس
        </el-menu-item>
        <el-menu-item index="3">
            <app-writing-icon/>
            مطالب
        </el-menu-item>
        <el-menu-item index="4">
            <app-chat-bubble-icon/>
            درباره ما
        </el-menu-item>
        <el-menu-item index="5">
            <app-mail-icon/>
            تماس با ما
        </el-menu-item>
        <el-menu-item index="6">
            <template v-if="!checkAuthentication()">
                <app-male-person-icon/>
                ورود به حساب کاربری
            </template>
            <template v-if="checkAuthentication()">
                <app-sing-out-icon></app-sing-out-icon>
                خروج
            </template>
        </el-menu-item>
    </el-menu>
</template>

<script>
    /* eslint-disable */
    export default {
        name: 'AppHeader',
        data() {
            return {
                activeIndex: '1',
                activeIndex2: '1'
            };
        },
        mounted() {
            this.checkAuthentication();
        },
        methods: {
            checkAuthentication() {
                return (localStorage.getItem('auth') != null);
            },
            handleSelect(key, keyPath) { // eslint-disable-next-line
                console.log(key, keyPath);
                if (key == 1) {
                    this.$router.push({name: 'home'});
                }
                else if (key == 2) {
                    // this.$router.push({name: 'dashboard'});
                }
                else if (key == 3){
                    this.$router.push({name: 'writings'});
                }
                else if (key == 6) {
                    this.checkAuthentication()? this.signOut(): this.$router.replace({name: 'auth-signin'});
                }
            },
            signOut() {
                // localStorage.clear();
                this.$http.post(
                    `${this.apiURL}/user/signout`,
                    { refreshToken: JSON.parse(localStorage.getItem('auth')).refreshToken }
                ).then(
                    (response) => {
                        localStorage.removeItem('auth');
                        this.$router.push({name: 'home'});
                    }
                ).catch((err) => {});
            },
        }
    }
</script>

<style lang="scss" scoped>
    .el-menu {
        padding-right: 0;
        width: 100%;
        direction: rtl;
        background-color: rgba(256, 256, 256, 0.7);

        .el-menu-item {
            float: right;
        }
    }
</style>
